import { InjectionToken } from '@angular/core';
import { Environment } from '@fitscovery/common/environments';

export const APP_ENVIRONMENT = new InjectionToken<Environment>('partner.data-access.environment');